import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { PontosCriticosTiposService } from '../services/pontos-criticos-tipos.service';


@Injectable({
  providedIn: 'root'
})
export class PontosCriticosTiposResolver implements Resolve<boolean> {

  constructor(private service: PontosCriticosTiposService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}